import { render, staticRenderFns } from "./ReportMetrics.vue?vue&type=template&id=4db6c088&"
import script from "./ReportMetrics.vue?vue&type=script&lang=js&"
export * from "./ReportMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports